// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".table-container td[data-v-7c080248]{cursor:auto !important}", "",{"version":3,"sources":["/Users/niwashouta/projects/kgi_sfa/app/javascript/erp_src/view/rubber/tabs/AnticipatedMatterProductTab.vue"],"names":[],"mappings":"AAEC,qCACC,sBAAA","file":"AnticipatedMatterProductTab.vue","sourcesContent":["\n.table-container {\n\ttd {\n\t\tcursor: auto !important;\n\t}\n}\n"]}]);
// Exports
module.exports = exports;
